/**
 * @param e event
 * @param charactersToDeny array of characters
 * @returns {boolean} - false if character is denied, true if character is allowed
 */
export const onKeyDownDenyCharacters = (e, charactersToDeny) => {
  if (charactersToDeny.includes(e.key)) {
    e.preventDefault();

    return false;
  }

  return true;
};

export const nonNumericNumberInputCharacters = [
  'e',
  'E',
  '-',
  '.',
  ',',
  '+',
];
